import styled from "styled-components";
import { Box } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

export const TableHeader = styled(Box)`
	display: flex;
	justify-content: space-between;
`;
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.custom_palette.color1,
		color: theme.palette.common.white,
		fontWeight: "bold",
		fontSize: 16
	}
}));
